import { handleActions } from 'redux-actions'
import { fromJS } from 'immutable'
import * as Actions from 'actions/saved_searches'
import * as FilterActions from 'actions/filter'
import * as AppActions from 'actions/app'

export const resetState = fromJS({
  selectedSavedSearch: {
    nameDe: '',
    nameEn: '',
    nameFr: '',
    nameRu: '',
    nameZh: '',
    nameJa: '',
    nameIt: ''
  }
})

export const initialState = resetState.merge({
  executedSavedSearch: null
})

export default handleActions({
  [Actions.showEditSavedSearchDialog]: (state, action) => {
    if (action.payload) {
      return state.set('selectedSavedSearch', action.payload)
    }

    return state.merge(resetState)
  },

  [Actions.showSavedSearchAlertHistoryDialog]: (state, action) => state.set('selectedSavedSearch', action.payload),

  [Actions.updateSelectedSavedSearch]: (state, { payload: savedSearch }) => state.set('selectedSavedSearch', savedSearch),

  [Actions.showRemoveSavedSearchDialog]: (state, { payload: savedSearch }) => state.set('selectedSavedSearch', savedSearch),

  [Actions.setExecutedSavedSearch]: (state, { payload: savedSearch }) => state.set('executedSavedSearch', savedSearch),

  [Actions.saveSavedSearchSuccess]: (state, { payload: savedSearch }) => {
    if (state.get('executedSavedSearch') && savedSearch.id === state.getIn(['executedSavedSearch', 'id'])) {
      return state.set('executedSavedSearch', fromJS(savedSearch))
    }

    return state
  },

  [FilterActions.resetFilters]: () => initialState,

  [AppActions.resetState]: () => initialState
}, initialState)
